const { db } = require("../services/Firebase");

export const getCurrentUser = () => {
    let temp = localStorage.getItem('currentUser');
    if (temp) {
        return JSON.parse(temp);
    } else {
        return {};
    }
}

export const getUserById = async (uid) => {
    let result = {};

    await db.collection('Users')
        .doc(uid)
        .get()
        .then((documentSnapshot) => {
            result = documentSnapshot.data();
        })
        .catch((e) => {
            console.log(e);
        })

    return result;
}